import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { TICKET_CORPORATE_CREDIT_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { TICKET_CORPORATE_CREDIT_COLUMNS } from '../../../../config/columns';
import {
  clearTicketCorporateCredits,
  getTicketCorporateCredits,
} from '../../../../actions/corporate/TicketCorporateCredit';

export const TicketCorporateCredits = ({
  breadcrumbs,
  ticketCorporateCredits,
  loading,
  dispatchGetTicketCorporateCredits,
  dispatchClearTicketCorporateCredits,
}) => {
  useLayoutEffect(() => () => dispatchClearTicketCorporateCredits(), []);

  const data = ticketCorporateCredits.get('content') || [];
  const pages = ticketCorporateCredits.get('totalPages') || null;
  const defaultPageSize =
    ticketCorporateCredits.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Créditos Corporativos de Pasajes"
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: TICKET_CORPORATE_CREDIT_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetTicketCorporateCredits,
        loading,
        modelPath: TICKET_CORPORATE_CREDIT_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetTicketCorporateCredits: getTicketCorporateCredits,
  dispatchClearTicketCorporateCredits: clearTicketCorporateCredits,
};

const mapStateToProps = ({ CorporateUnit }) => ({
  breadcrumbs: [
    ...CorporateUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Créditos Corporativos de Pasajes',
      href: TICKET_CORPORATE_CREDIT_PATH,
    },
  ],
  ticketCorporateCredits: CorporateUnit.TicketCorporateCredit.getIn([
    'all',
    'content',
  ]),
  loading: CorporateUnit.TicketCorporateCredit.getIn(['all', 'loading']),
});

TicketCorporateCredits.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  ticketCorporateCredits: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetTicketCorporateCredits: PropTypes.func.isRequired,
  dispatchClearTicketCorporateCredits: PropTypes.func.isRequired,
};

TicketCorporateCredits.defaultProps = {
  ticketCorporateCredits: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketCorporateCredits);
